/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBindingControl = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M5 2a3 3 0 0 1 2.983 3.324L14.799 8.6a4 4 0 1 1 .195 5.04l-3.234 1.825a5 5 0 1 1-.984-1.742l3.315-1.87a4.016 4.016 0 0 1-.054-1.399L7.115 7.127A3 3 0 1 1 5 2zm2 12a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm11-5a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM5 4a1 1 0 1 0 .001 2.001A1 1 0 0 0 5 4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBindingControl as BindingControl };
